import React, { useEffect, useState } from "react";
import {
  Col,
  Modal,
  Nav,
  Row,
  Tab,
  Image,
  InputGroup,
  FormControl,
  Button,
} from "react-bootstrap";
import icTitle from "../../../../assets/images/ic-edit-modal.svg";
import DeleteBox from "../../../../assets/images/ic-deletebox.svg";
import Add from "../../../../assets/images/ic-add.svg";
import ENGModalBody from "../../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../../components/modal/ENGModalHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
import Edit from "../../../../assets/images/ic-edit.svg";
import { formatDate } from "../../../../constant/DateFormat";
//import TextField from "../../../../components/textField/TextField";
//import EditTextField from "../../../../components/textField/EditTextField";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  UpdateMessages,
  selectUpdatedMessages,
} from "../../../../features/messages/updateMessageSlice";
import { DeleteMessages } from "../../../../features/messages/DeleteMessageSlice";
import swal from "sweetalert";
import { InsertMessages } from "../../../../features/messages/insertMessageSlice";
import FileUploadImage from "../../../../components/textField/FileUploadImages";
import { GetMessages } from "../../../../features/messages/messageSlice";
import { isPermited } from "../../../../features/localStorage";
import { dev } from "../../../../features/network/ApiCall";

type newMessage = {
  name: string;
  designation: string;
  message: string;
  image: string;
  companyId: string;
  fileName: string;
};

const EditMessagesModal = ({
  data,
  handleAddMessage,
}: {
  data: any;
  handleAddMessage: any;
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [messgeData, setMessageData] = useState(data);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const [file, setFile] = useState("");
  const [name, setname] = useState<string>("");
  const [designation, setdesignation] = useState<string>("");
  const [message, setmessage] = useState<string>("");
  const [image, setimage] = useState<string>("");
  const [inputFileHide, setinputFileHide] = useState(true);
  const [readonly, setReadonly] = useState(true);
  const [messageId, setmessageId] = useState(1);
  const [isEditMessage, setisEditMessage] = useState(false);
  const [editMessageItem, setEditMessageItem] = useState("");
  const [loading, setLoading] = useState(false);
  const onname = (event: React.ChangeEvent<HTMLInputElement>) =>
    setname(event.target.value);
  const ondesignation = (event: React.ChangeEvent<HTMLInputElement>) =>
    setdesignation(event.target.value);
  const onmessage = (event: React.ChangeEvent<HTMLTextAreaElement>) =>
    setmessage(event.target.value);
  const onimage = (event: React.ChangeEvent<HTMLInputElement>) =>
    setimage(event.target.value);

  const dispatch = useAppDispatch();

  const setNewGift = useAppSelector(selectUpdatedMessages);
  // const [checkAddButton, setCheckAdd] = useState(true)
  const [messages, setMessages] = useState<any>([]);
  const [addClickButton, setaddClickButton] = useState(false);

  useEffect(() => {
    // async function checkAddButton() {
    //   console.log(checkAddButton, data.lenght, "data.lenghtdata.lenght")
    //   if (data.lenght == 3) {
    //     await setCheckAdd(false)
    //     console.log(checkAddButton, data.lenght, "data.lenghtdata.lenght")
    //   }
    // }
    // checkAddButton();
    setMessages(data);
  }, [data]);

  const addNewMessage = () => {
    setaddClickButton(true);
    if (isEditMessage !== true) {
      let newMessage: newMessage = {
        name: "",
        designation: "",
        message: "",
        image: "",
        companyId: "1",
        fileName: "Anand",
      };

      let prevMessages: any[] = [...messages];
      prevMessages.push(newMessage);
      setMessages(prevMessages);
      setinputFileHide(false);
      setReadonly(false);
    }
  };
  const [editName, setEditName] = useState("");
  const [editDesignation, setEditDesignation] = useState("");
  const [editMessage, setEditMessage] = useState("");
  const [editFile, setEditFile] = useState("");
  const onEditMessage = (val: any) => {
    //console.log(val, "oneditmessage")
    setReadonly(false);
    setmessageId(val.id);
    setisEditMessage(true);
    setaddClickButton(true);
    setEditMessageItem(val);
    setEditName(val.name);
    setEditDesignation(val.designation);
    setEditMessage(val.message);
    setEditFile(val.image);
  };
  const onReplaceFile = () => {
    //  alert(inputFileHide)
    setinputFileHide(false);
  };
  //alert(data.length)
  const onSubmits = async (event: any) => {
    event.preventDefault();
    //alert(isEditMessage)
    setLoading(true);
    if (isEditMessage !== true) {
      if (name !== "") {
        let postData = {
          name: name,
          designation: designation,
          message: message,
          image: file,
          status: 0,
        };

        await dispatch(InsertMessages(postData));
        await dispatch(GetMessages());
        await setLoading(false);
        await setaddClickButton(false);
        await handleClose();
        //window.location.reload()
      }
    } else {
      let data;
      if (name !== "" || designation !== "" || message !== "" || file !== "") {
        data = {
          name: name,
          designation: designation,
          message: message,
          image: file,
          status: 0,
        };
      } else {
        data = {
          name: editName,
          designation: editDesignation,
          message: editMessage,
          image: editFile,
          status: 0,
        };
      }
      var newdata = {
        data: data,
        id: messageId,
      };

      setReadonly(true);
      await dispatch(UpdateMessages(newdata));
      await dispatch(GetMessages());
      setaddClickButton(false);
      setLoading(false);
      handleClose();
    }
  };
  const onDeleteMessge = async (val: any) => {
    swal({
      title: "Are you sure delete record?",
      text: "Once deleted, you will not be able to recover this record",
      icon: "warning",
      dangerMode: true,
    }).then(async (willDelete: any) => {
      if (willDelete) {
        swal(" Your record has been deleted!", {
          icon: "success",
        });
        await dispatch(DeleteMessages(val.id));
        await dispatch(GetMessages());
        await window.location.reload();
      } else {
        swal("Your record is safe!");
      }
    });
  };

  return (
    <>
      <a
        onClick={handleShow}
        style={{
          backgroundColor: "#fff",
          color: "#e31837",
          // fontFamily: "Saira",
          fontWeight: 600,
          fontSize: "12px",
          lineHeight: "2",
          cursor: "pointer",
        }}
      >
        <Image src={Edit} width={20} /> EDIT
      </a>

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="xl"
        keyboard={false}
      >
        <ENGModalHeader
          icon={icTitle}
          title="Edit message from Mahindra leaders"
        />
        <ENGModalBody
          contents={
            <>
              <Tab.Container defaultActiveKey="1">
                <Tab.Content>
                  {data.length > 0
                    ? data.map((val: any, index: any) => {
                        return (
                          <Tab.Pane eventKey={index + 1} key={val.id}>
                            <Row style={styles.divWhite}>
                              <Col sm={3}>
                                <div style={styles.colBorder} className="px-3">
                                  <span style={styles.heading}>
                                    Last modified By
                                  </span>
                                  <br />
                                  <span style={styles.data}>
                                    {val.updatedBy}
                                  </span>
                                </div>
                              </Col>
                              <Col sm={3}>
                                <div style={styles.colBorder} className="px-3">
                                  <span style={styles.heading}>
                                    Modified on
                                  </span>
                                  <br />
                                  <span style={styles.data}>
                                    {formatDate(val.updatedDate)}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                        );
                      })
                    : null}

                  {messages.length == 0 ? (
                    <span style={styles.text1}>
                      You have no declared Messages.
                    </span>
                  ) : (
                    <span></span>
                  )}
                </Tab.Content>

                <Row style={styles.divWhite} className="mx-auto py-0 mt-3">
                  <Col sm={10} className="px-0">
                    <Nav>
                      {messages.length > 0 ? (
                        messages.map((val: any, index: any) => {
                          return (
                            <Nav.Item style={styles.tabHeading} key={val.id}>
                              <Nav.Link className="tabs1" eventKey={index + 1}>
                                Message {index + 1}
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })
                      ) : (
                        <span style={styles.text1}>
                          You have no declared Messages.
                        </span>
                      )}
                    </Nav>
                  </Col>
                  {data.length < 3 ? (
                    <Col sm={2} className="pe-0">
                      {isPermited(7, 2) && (
                        <a
                          className="float-end"
                          onClick={addNewMessage}
                          style={styles.link}
                        >
                          <Image src={Add} /> Add Message
                        </a>
                      )}
                    </Col>
                  ) : null}
                </Row>
                <div style={styles.line}></div>
                <Row style={styles.divWhite} className="mx-auto">
                  <Col sm={12} className="px-0">
                    <Tab.Content>
                      {messages.length > 0 ? (
                        messages.map((val: any, index: any) => {
                          return (
                            <Tab.Pane eventKey={index + 1} key={val.id}>
                              <form onSubmit={onSubmits}>
                                <Row>
                                  <Col sm={3}>
                                    <Row>
                                      <Col sm={12}>
                                        <Image
                                          src={`${dev}/admin/download?fileName=${val.image}`}
                                          style={{
                                            width: "100%",
                                            borderRadius: "50%",
                                          }}
                                        />
                                        {/* <div style={styles.data} className="mt-4">{val.image}</div>
                                                                    <div style={styles.heading}>100 KB</div> */}
                                        {/* <div className="my-1"><a style={styles.link} onClick={onReplaceFile}>Replace</a></div> */}
                                      </Col>
                                      <Col sm={12} className="my-3">
                                        <FileUploadImage
                                          setFile={setFile}
                                          fileValue={val.image}
                                          title="File"
                                          fileType="JPG/JPEG/PNG"
                                        />
                                      </Col>

                                      <Col sm={12} className="my-3">
                                        <div className="floating-label-group">
                                          <input
                                            type="text"
                                            id="name"
                                            className="textstyle"
                                            required
                                            onChange={(
                                              ev: React.ChangeEvent<HTMLInputElement>
                                            ): void => setname(ev.target.value)}
                                            readOnly={readonly}
                                            name={name}
                                            defaultValue={val.name}
                                          />
                                          <label className="floating-label">
                                            Name
                                          </label>
                                        </div>
                                      </Col>

                                      <Col sm={12}>
                                        <div className="floating-label-group">
                                          <input
                                            type="text"
                                            id="Designation"
                                            readOnly={readonly}
                                            className="textstyle"
                                            name={designation}
                                            required
                                            //value={designation}
                                            onChange={(
                                              ev: React.ChangeEvent<HTMLInputElement>
                                            ): void =>
                                              setdesignation(ev.target.value)
                                            }
                                            defaultValue={val.designation}
                                          />
                                          <label className="floating-label">
                                            Designation
                                          </label>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col sm={9}>
                                    <textarea
                                      rows={20}
                                      id="username"
                                      className="form-control"
                                      name={message}
                                      readOnly={readonly}
                                      required
                                      //value={message}
                                      onChange={(
                                        ev: React.ChangeEvent<HTMLTextAreaElement>
                                      ): void => setmessage(ev.target.value)}
                                      defaultValue={val.message}
                                    />
                                  </Col>
                                </Row>
                              </form>
                              {addClickButton !== true ? (
                                <Row className="mt-2">
                                  <Col sm="10" className="text-right">
                                    {isPermited(7, 3) && (
                                      <a
                                        style={styles.link}
                                        onClick={() => onEditMessage(val)}
                                      >
                                        <Image src={Edit} /> Edit Message
                                      </a>
                                    )}
                                  </Col>
                                  <Col sm="2" className="text-right">
                                    {isPermited(7, 4) && (
                                      <a
                                        style={styles.link}
                                        onClick={() => onDeleteMessge(val)}
                                      >
                                        <Image src={DeleteBox} /> Delete Message
                                      </a>
                                    )}
                                  </Col>
                                </Row>
                              ) : null}
                              <Modal.Footer style={styles.bgGrey}>
                                <Button
                                  type="button"
                                  style={styles.button}
                                  disabled={loading}
                                  onClick={onSubmits}
                                >
                                  {loading && (
                                    <i
                                      className="fa fa-refresh fa-spin"
                                      style={{
                                        marginRight: "1px",
                                        fontSize: "18px",
                                        color: "#fff",
                                      }}
                                    />
                                  )}
                                  &nbsp;&nbsp;&nbsp; SAVE CHANGES
                                </Button>
                              </Modal.Footer>
                              {/* <ENGModalFooter closeMethod={onSubmits} type="button" title="SAVE CHANGES" /> */}
                            </Tab.Pane>
                          );
                        })
                      ) : (
                        <span style={styles.text1}>
                          You have no declared Messages.
                        </span>
                      )}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </>
          }
        />
      </Modal>
    </>
  );
};

const styles: any = {
  floatinglabel: {
    fontSize: "12px",
    color: "#6d6e71",
    fontWeight: "400",
    position: "relative",
    top: "-55px",
    left: "20px",
  },

  divWhite: {
    backgroundColor: "#fffff",
    padding: "24px",
  },
  tabHeading: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  line: {
    height: "1px",
    margin: "0px",
    backgroundColor: "#f4f4f4",
  },
  colBorder: {
    border: "solid 1px #e4e4e4",
  },
  colBorder1: {
    border: "solid 1px #e4e4e4",
    height: "100%",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "center",
  },
  heading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  data: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
    color: "black",
  },
  link: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
    lineHeight: "2",
    textTransform: "uppercase",
    textDecoration: "none",
    float: "right",
  },
  bgGrey: {
    backgroundColor: "#faf9f9",
  },
  button: {
    padding: "13px 40px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
  },
};

export default EditMessagesModal;
